import React, { cloneElement, useEffect } from 'react';
import { useLocation } from 'react-router';

import { AppHeader } from '~/components/app-header/AppHeader';
import { ChatInput, ChatInputProps } from '~/components/chat';
import { useTouchDevice } from '~/hooks/MediaQueryHook';
import { mobileAlfredPaths } from '~/Root';
import { AppRoute } from '~/routes';
import { appPaths } from '~/routes/app-paths';
import { useReasonerParams } from '~/views/alfred/research/hooks/useReasonerParams';
import { useChatNavigation } from '~/views/alfred/use-chat-navigation/useChatNavigation';
import { MarketInsightDrawerRender } from '~/views/dashboard/whats-new-widget/components/market-insight-drawer/MarketInsightDrawerRender';
import { ScenarioInsightsLegacyDrawerRender } from '~/views/insights/components/insights-legacy-drawer/ScenarioInsightsLegacyDrawerRender';
import { Widgets } from '~/views/widgets/Widgets';
import { InsightDrawerShell } from '~/widgets/insight-drawer-shell/InsightDrawerShell';
import { MarketCatalystDrawer } from '~/widgets/market-catalyst-drawer/MarketCatalystDrawer';

import { checkIsMobile } from '../ProtectedView';
import styles from './View.module.scss';

export interface AccountViewProps {
  config: AppRoute;
  showHeader: boolean;
}

export const View = ({ config, showHeader }: AccountViewProps) => {
  const location = useLocation();
  const isTouchDevice = useTouchDevice();

  const { navigateToConversation } = useChatNavigation();
  const { conversationId } = useReasonerParams();

  const { element } = config;

  const content = cloneElement(element, {
    renderChatInput: (props?: ChatInputProps) => <ChatInput {...props} />,
  });

  const isMobileAlfredPath =
    mobileAlfredPaths.includes(location.pathname) && isTouchDevice;

  useEffect(() => {
    if (checkIsMobile() && location.pathname !== appPaths.alfred) {
      navigateToConversation(conversationId);
    }
  }, [conversationId, isTouchDevice, location.pathname]);

  return (
    <>
      {showHeader && !isMobileAlfredPath && <AppHeader />}
      <div className={styles.viewRoot} id={'root-view'}>
        {!isMobileAlfredPath && (
          <>
            <Widgets />
            <InsightDrawerShell />
            <ScenarioInsightsLegacyDrawerRender />
            <MarketInsightDrawerRender />
            <MarketCatalystDrawer />
          </>
        )}
        {content}
      </div>
    </>
  );
};
